<template>
<div>
    <v-row>
        <v-col cols="6">
            <p class="m-0 headlinee">{{$t('Filter by') }} </p>
        </v-col>
        <v-col cols="6">
            <v-divider></v-divider>
        </v-col>
    </v-row>
    <v-expansion-panels accordion multiple flat v-model="mainPanel">
        <v-expansion-panel>
                <v-expansion-panel-header>
                <template v-slot:default="{ open }">
                  {{ $t('Filters') }}
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content >
         
    <v-expansion-panels accordion multiple flat  v-model="panels">

        <v-expansion-panel v-for="(filter , idx) in curFilters" :key="idx">
            <v-expansion-panel-header>
                <template v-slot:default="{ open }">
                    <b class="filterNames"> {{ filter.name }} </b>
                </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content v-if="filter.type === 'SELECT'">
                <p style="cursor:pointer" v-for="(item , idx) in filter.values" @click="selectFilter(filter , item)" :key="idx">{{item.key}}</p>
            </v-expansion-panel-content>

            <v-expansion-panel-content v-else>
                <v-row>
                    <div class="px-4 w-100 m-0">
                        <v-range-slider v-if="getPrice" v-model="range" :max="filter.values[1].value" :min="filter.values[0].value" class="align-center">
                        </v-range-slider>
                    </div>
                    <div class="px-4 text-center w-100">
                        <p>{{range[0]}} - {{range[1]}}</p>
                    </div>
                </v-row>
            </v-expansion-panel-content>

        </v-expansion-panel> 
    </v-expansion-panels>
       </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</div>
</template>

<style>
    .filterNames{
        text-transform: capitalize;
    }
</style>

<script>
export default {
    props: {
        curFilters: {
            type: Array
        },
        value: {
            type: Array
        },
    },
    mounted(){
          this.onResize();
          window.addEventListener('resize', this.onResize)

    },
    data() {
        return {
            panels: [],
            mainPanel: [0],
            text: '',
            getPrice: true,
            min: 0,
            max: 1000,
            slider: 40,
            range: [0, 10000],
        };
    },
    watch:{
        curFilters(value){
            let prices = value.find(e => e.type === 'RANGE').values;
            this.getPrice = false;
            prices[0].value = Math.floor(prices[0].value);
            prices[1].value = Math.ceil(prices[1].value);
            this.range[0] = prices[0].value;
            this.range[1] = prices[1].value;
            var _t = this;
            setTimeout(function(){
                _t.getPrice = true;
            },200)
            this.onResize();
        },
        range(value){
            this.handlePrice(value)
        }
    },
    methods: {
        onResize(){
            if(window.innerWidth <= 959){
                this.panels = [];
                this.mainPanel = [];
            }
            else {
                 this.panels = [];
                 this.mainPanel = [0];
                for(let i=0;i<this.curFilters.length;i++)this.panels.push(i);
            }
        },
        selectFilter(filter, item) {
            this.$emit('selectFilter', {filter: filter,item: item});
        },
        sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
        },
         async  handlePrice(){
            let value = this.range;
            await this.sleep(1000);
            if (value[0] === this.range[0] && value[1] === this.range[1])
            {
                    //  console.log(this.range)
                    let filter = this.curFilters.find(e => e.type === 'RANGE');
                   this.$emit('changePrice', {filter: filter,item: this.range});
            }
        }
        
    },
};
</script>

<style>
.v-expansion-panel {
    background: #f9f9f9 !important;
}
</style>
